import { render, staticRenderFns } from "./AddQuotation.vue?vue&type=template&id=fc67a7c8"
import script from "./AddQuotation.vue?vue&type=script&lang=js"
export * from "./AddQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports